// @TODO <HEALTH2019> Added $rootScope
App.controller('RegisterCtrl', ['$scope', '$sce', '$state', '$http', '$mdDialog', 'Config', '$stateParams', 'authService', 'statesService', 'branchService', '$filter', 'profileService', 'dataUser', '$timeout', 'popUpService', '$rootScope', 'userInvitationService', function ($scope, $sce, $state, $http, $mdDialog, Config, $stateParams, authService, statesService, branchService, $filter, profileService, dataUser, $timeout, popUpService, $rootScope, userInvitationService) {
// @TODO </HEALTH2019>
        $scope.page = 'join';
        $scope.$emit('page', $scope.page);

        $scope.step = '';
        $scope.$emit('step', $scope.step);

        $scope.stateParams = $stateParams;

        $scope.nationality = 'POLISH';
        $scope.membership = 'MEMBER';

        setTimeout(function () {
            window.location.href = "/";
        }, 1);

        $scope.invitationToken = $scope.stateParams.invitationToken;
        if ($scope.invitationToken !== '' && $scope.invitationToken !== null) {
            $scope.membership = 'SUB_ACCOUNT';
        }

        $scope.ref = {};

        $scope.data = {
            login: '',
            password: '',
            person: {
                email: '',
                // birthdate: new Date('01/01/2000'),
                citizenshipType: '',
                firstName: '',
                // gender: 'MALE',
                identifier: '',
                identifierType: 'PESEL',
                lastName: '',
                // mothersMaidenName: '',
                // otherCitizenship: '',
                phone: '',
                // staffId: '',
                branch: '',
                branchId: '',
                type: "MAIN_USER",
                hrNumber: '',
                hrNumberWithoutPrefix: ''
            },
            status: "NOT_VERIFIED",
            invitationToken: $scope.invitationToken
        };

        if ($rootScope.CONFIGURATOR.register.isDisabled) {
            popUpService.showPopUp({
                ev: '', head: '', content: 'Możliwość rejestracji Konta Użytkownika została zablokowana.',
                text: 'Strona Główna', target: 'root.dashboard', clickOutsideToClose: false, hideClose: true
            });
        }

    if ($scope.stateParams.invitationToken) {
        userInvitationService.getInvitation($scope.stateParams.invitationToken).then(function (success) {
            if (success.status === 200 && success.data && success.data.status === 'PENDING') {
                $scope.data.person.email = success.data.email;
            } else {
                $scope.data.invitationToken = null;
            }
        });
    } else {
        $scope.data.invitationToken = null;
    }
    if ($rootScope.CONFIGURATOR.register.isBirthPlaceEnabled) {
        $scope.data.person.birthplace = '';
    }

        $scope.data.agreements = [{
                id: 0,
                content: '<span>Zawieram umowę o świadczenie usług drogą elektroniczną poprzez założenie konta użytkownika. <br/> Zostałem poinformowany/poinformowana, że w każdej chwili mogę wypowiedzieć umowę o świadczenie usług drogą elektroniczną bez wskazywania przyczyny. Wypowiedzenie przeze mnie umowy oznacza zakończenie możliwości korzystania z Portalu i produktów/usług oferowanych za pośrednictwem Portalu.</span>&nbsp;<span class="required">*</span>',
                accepted: false
            },
            {
                id: 1,
                content: '<span>Zapoznałem/zapoznałam się z <a ui-sref="root.regulations" title="" target="_blank">Regulaminem świadczenia usług drogą elektroniczną</a> i <a ui-sref="root.privacypolicy" title="" target="_blank">Polityką prywatności</a>.</span></span>&nbsp;<span class="required">*</span>',
                accepted: false
            },
            {
                id: 2,
                content: '<span>Zapoznałem/zapoznałam się z <a href="" ng-click="showInformationObligation()">treścią obowiązku informacyjnego</a>.</span></span>&nbsp;<span class="required">*</span>',
                accepted: false
            }
        ];

        $scope.data.consents = [{
                id: 0,
                content: '<label>1. W celu oferowania Ci przez nas produktów i usług bezpośrednio, w tym dobierania ich pod kątem Twoich potrzeb z pomocą profilowania?</label>',
                accepted: null
            },
            {
                id: 1,
                content: '<label>2. W celu oferowania Ci bezpośrednio (marketing bezpośredni) produktów i usług firm z nami współpracujących (naszych partnerów), w tym dobierania ich pod kątem Twoich potrzeb z pomocą profilowania?</label>',
                accepted: null
            },
            {
                id: 2,
                content: '<label>3. Na przekazywanie przez nas treści, dotyczących naszej oferty na podany numer telefonu (w tym przy użyciu automatycznych systemów wywołujących w rozumieniu ustawy z dnia 16 lipca 2004 r. Prawo telekomunikacyjne)?</label>',
                accepted: null
            },
            {
                id: 3,
                content: '<label>4. Na przetwarzanie swoich danych osobowych przez podmioty współpracujące z nami w celu marketingu bezpośredniego dotyczącego produktów i usług oferowanych przez te podmioty (wykonywanego przy użyciu telekomunikacyjnych urządzeń końcowych oraz automatycznych systemów wywołujących , zgodnie z art. 172 ustawy z dnia 16 lipca 2004r. Prawo telekomunikacyjne)?</label>',
                accepted: null
            }
        ];

        $scope.$watch('data.password', function () {
            if (!$scope.data.password) {
                $scope.strongPassword = 0;
                return 0;
            } else {
                $scope.strongPassword = $scope.data.password.length * 10 / 2;

                if ($scope.strongPassword <= 40) {
                    $scope.strongPasswordLabel = 'Słabe';
                } else if ($scope.strongPassword <= 60) {
                    $scope.strongPasswordLabel = 'Średnie';
                } else if ($scope.strongPassword <= 80) {
                    $scope.strongPasswordLabel = 'Dobre';
                } else {
                    $scope.strongPasswordLabel = 'Znakomite';
                }
            }
        });

        $scope.ref.selectedBranch = null;
        $scope.ref.searchTextBranch = null;

        $scope.register = function () {
            var vm = this;

            var el = $(vm.form.$$element[0]).find('button[type="submit"]');

            if (!vm.form.$valid) {
                $scope.showPopUp('', 'Uzupełnij pola', 'Aby dokończyć rejestrację wypełnij wszystkie wymagane pola.', '');
                document.body.scrollTop = document.documentElement.scrollTop = 80;
                return 0;
            }

            if ($scope.data.password !== $scope.password_repeat) {
                $scope.showPopUp('', 'Hasła się różnią', 'Podane przez Ciebie hasła różnią się od siebie.', '');
                return 0;
            }

            if (!$scope.data.agreements[0].accepted ||
                !$scope.data.agreements[1].accepted ||
                !$scope.data.agreements[2].accepted) {
                $scope.showPopUp('', 'Zaakceptuj oświadczenia', 'Aby dokończyć rejestrację zaakceptuj wymagane oświadczenia.');
                return 0;
            }

            if ($scope.data.consents[0].accepted === null ||
                $scope.data.consents[1].accepted === null ||
                $scope.data.consents[2].accepted === null ||
                $scope.data.consents[3].accepted === null) {
                $scope.showPopUp('', 'Dokonaj wyboru przy zgodach', 'Aby dokończyć rejestrację zaznacz Tak lub Nie przy zgodach.');
                return 0;
            }

            if ($scope.nationality === 'POLISH') {
                if ($filter('isNoAdultFromIdentifier')($scope.data.person.identifier)) {
                    $scope.data.person.identifier = '';
                    $scope.showPopUp('', 'Niepoprawny PESEL', 'Podany numer PESEL wskazuje, że nie masz 18 lat. Konto użytkownika możesz zarejestrować, jeśli jesteś osobą pełnoletnią', '');
                    return 0;
                }
            } else {
                if ($filter('isNoAdultFromBirthdate')($scope.data.person.birthdate)) {
                    // $scope.data.person.birthdate = new Date('01/01/2000');
                    $scope.showPopUp('', 'Niepoprawny PESEL', 'Podany numer PESEL wskazuje, że nie masz 18 lat. Konto użytkownika możesz zarejestrować, jeśli jesteś osobą pełnoletnią', '');
                    return 0;
                }
            }

            $scope.data.person.identifierType = ($scope.nationality !== 'POLISH') ? 'OTHER' : 'PESEL';
            $scope.data.person.identifier = ($scope.nationality !== 'POLISH') ? $scope.id : $scope.data.person.identifier;
            $scope.data.person.birthdate = ($scope.nationality !== 'POLISH') ? $filter('getDateFromBirthdate')($scope.data.person.birthdate) : $filter('getDateFromIdentifier')($scope.data.person.identifier);
            $scope.data.person.citizenshipType = $scope.nationality;

            $scope.data.person.branch = $scope.ref.selectedBranch.name;
            $scope.data.person.branchId = $scope.ref.selectedBranch.id;
            if ($rootScope.CONFIGURATOR.healthInsuranceWithPayments.isEnabled) {
                if ($scope.membership === 'MEMBER' && $scope.invitationToken !== '') {
                    $scope.data.person.hrNumber = $rootScope.CONFIGURATOR.hrNumber.pre + $scope.data.person.hrNumberWithoutPrefix;
                } else {
                    $scope.data.person.hrNumber = null;
                }
            }

            if ($stateParams.redirectToThirdStep) {
                registerWithLogin(el);
                return;
            }

            registerWithLogin(el);
        };

        function registerWithLogin(el) {
            if (el.hasClass('disabled')) {
                return 0;
            } else {
                el.addClass('disabled');
            }

            authService.register($scope.data).then(function (data) {
                if (data.status === 200) {
                    if (data.data.verificationRequired) {
                        popUpService.showPopUp({ev: '', head: 'Twoje konto zostało zarejestrowane', content: 'Aby dokończyć rejestrację, przejdź do poczty i kliknij w link przesłany w wiadomości e-mail, aby móc korzystać z naszej platformy.', text: 'Ok', target: 'root.login', clickOutsideToClose: false});
                    } else {
                        authenticateUser($scope.data);
                    }
                } else {
                    if (data.data.message === 'DuplicateIdentifierException') {
                        popUpService.showPopUpWithError(data.data, {ev: '', head: 'Niepoprawny Numer PESEL', content: 'Podany Numer PESEL nie może zostać użyty. Sprawdź poprawność i upewnij się czy nie posiadasz już Konta użytkownika, przechodząc procedurę przypominania logowania.', text: '', target: ''});
                    } else if (data.data.message === 'DuplicateIdentifierTechnicalUserException') {
                        popUpService.showPopUpWithError(data.data, {ev: '', head: 'Niepoprawny Numer PESEL', content: 'Podany Numer PESEL nie może zostać użyty. Sprawdź poprawność i upewnij się czy nie posiadasz już deklaracji w systemie. Wyślij wiadomość na <a href="mailto:kontakt@xilium.pl">kontakt@xilium.pl</a> w celu weryfikacji.', text: '', target: ''});
                    } else if (data.data.message === 'DuplicateLoginException') {
                        popUpService.showPopUpWithError(data.data, {ev: '', head: 'Niepoprawny login', content: 'Podany login nie może zostać użyty. Podaj inny.', text: '', target: ''});
                    } else if (data.data.message === 'DuplicateEmailException') {
                        popUpService.showPopUpWithError(data.data, {ev: '', head: 'Rejestracja nieudana', content: 'Podany adres e-mail jest już zajęty, użyj innego.', text: '', target: ''});
                    } else if (data.data.message === 'DuplicateHRNumberException') {
                        popUpService.showPopUpWithError(data.data, {ev: '', head: 'Niepoprawny '+ $rootScope.CONFIGURATOR.hrNumber.nameLong, content: 'Wskazany ' + $rootScope.CONFIGURATOR.hrNumber.nameLong + ' został już przypisany do innego użytkownika. Sprawdź poprawność numeru i spróbuj ponownie. W przypadku problemów prosimy o kontakt z naszą Infolinią.', text: '', target: ''});
                    } else if (data.data.message === 'DuplicateHRNumberTechnicalUserException') {
                        popUpService.showPopUpWithError(data.data, {ev: '', head: 'Niepoprawny '+ $rootScope.CONFIGURATOR.hrNumber.nameLong, content: 'Wskazany ' + $rootScope.CONFIGURATOR.hrNumber.nameLong + ' został już przypisany do innego użytkownika. Sprawdź poprawność i upewnij się czy nie posiadasz już deklaracji w systemie. Wyślij wiadomość na <a href="mailto:kontakt@xilium.pl">kontakt@xilium.pl</a> w celu weryfikacji.', text: '', target: ''});
                    } else if (data.data.message === 'UserNotAllowedInPlatformException') {
                        popUpService.showPopUpWithError(data.data, {head: 'Rejestracja nieudana', content: 'Nie jesteś uprawniony do założenia konta w systemie.'});
                    } else {
                        popUpService.showPopUpWithError(data.data, {head: 'Rejestracja nieudana', content: 'Niestety nie udało się zarejestrować konta, skontaktuj się z administratorem.'});
                    }
                }

                $timeout(function() {
                    el.removeClass('disabled');
                }, 1500);
            });
        }

        function authenticateUser(data) {
            authService.authenticate(data.login, data.password).then(function (response) {
                if (response.status === 200) {
                    window.sessionStorage.setItem('isLogged', response.data.access_token);
                    window.sessionStorage.setItem('refresh_token', response.data.refresh_token);

                    updateUsersData();
                } else {
                    popUpService.showPopUpWithError(response, {ev: '', head: 'Błąd logowania', content: 'Dane są nieprawidłowe lub konto nie zostało aktywowane. W przypadku problemów, prosimy o kontakt.', text: '', target: ''});
                }
            });
        }

        function updateUsersData() {
            profileService.dataUser().then(function (userResponse) {
                if (userResponse.status === 200) {
                    dataUser.update(true, $stateParams);
                }
            });
        }

        $scope.showInformationObligation = function () {
            $scope.showPopUpInformationObligation('');
        };

        function PopUpInfoCtrl($scope, $mdDialog, locals) {
            $scope.locals = locals;

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.confirm = function () {
                $mdDialog.hide($scope.locals);
            };
        }
        PopUpInfoCtrl.$inject = ['$scope', '$mdDialog', 'locals'];
        $scope.showPopUp = function (ev, head, content, text, target) {
            $mdDialog.show({
                controller: PopUpInfoCtrl,
                templateUrl: Config.TEMPLATES_DIR + 'PopUp/info-big.html',
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    head: head,
                    content: content,
                    button: {
                        text: text,
                        target: target
                    }
                }
            }).then(function (data) {

            }, function () {

            });
        };

        $scope.showPopUpInformationObligation = function (ev) {
            $mdDialog.show({
                controller: PopUpInfoCtrl,
                templateUrl: Config.TEMPLATES_DIR + 'PopUp/info-obligation.html',
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {}
            }).then(function (data) {

            }, function () {

            });
        };

        $scope.branch = [];
        branchService.dataBranchLists().then(function (data) {
            $scope.branch = $filter('hideBranchCargo')(data.data.data);
            // @TODO <HEALTH2019>
            if ($rootScope.CONFIGURATOR.selectFirstBranchAsDefault || !$rootScope.CONFIGURATOR.register.isBranchEnabled) {
                $scope.ref.selectedBranch = $scope.branch[0];
            }
            // @TODO </HEALTH2019>
        });

        // ##### FILTER ##### //
        $scope.ref.querySearchBranch = function (query) {
            var results = query ? $scope.branch.filter(createFilterForItem(query)) : $scope.branch;
            return results;
        };

        function createFilterForItem(query) {
            var lowercaseQuery = angular.lowercase(query);

            return function filterFn(items) {
                return (angular.lowercase(items.name).indexOf(lowercaseQuery) !== -1);
            };
        }

        $scope.$watchGroup(['data.person.identifier', 'data.person.birthdate'], function () {
            if ($scope.nationality === 'POLISH') {
                if ($filter('isNoAdultFromIdentifier')($scope.data.person.identifier)) {
                    $scope.data.person.identifier = '';
                    $scope.showPopUp('', 'Niepoprawny PESEL', 'Podany numer PESEL wskazuje, że nie masz 18 lat. Konto użytkownika możesz zarejestrować, jeśli jesteś osobą pełnoletnią', '');
                    return 0;
                }
            } else {
                if ($filter('isNoAdultFromBirthdate')($scope.data.person.birthdate)) {
                    // $scope.data.person.birthdate = new Date('01/01/2000');
                    $scope.showPopUp('', 'Niepoprawna data urodzenia', 'Podana data urodzenia wskazuje, że nie masz 18 lat. Konto użytkownika możesz zarejestrować, jeśli jesteś osobą pełnoletnią', '');
                    return 0;
                }
            }
        });

        $scope.$watch('data.person.email', function (oldVal, newVal) {
            if (oldVal !== newVal) {
                $scope.data.login = $scope.data.person.email;
            }
        });
    }
]);
